
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./phosphor-react.cjs.production.min.js')
} else {
  module.exports = require('./phosphor-react.cjs.development.js')
}



//////////////////
// WEBPACK FOOTER
// ./~/phosphor-react/dist/index.js
// module id = 76
// module chunks = 0